module.exports = __webpack_public_path__ + "img/header-diamondJewelryRosegold.18ba403.jpg";